import React , { Component } from 'react';

import ContentMenu from './contentMenu';
import ContentNews from './contentNews';
import ContentFirmAndPolicy from './contentFirmAndPolicy';
import ContentServiceAdvantage from './contentServiceAdvantage';
import ContentPartner from './contentPartner';
import ContentReserve from './contentReserve';
import ContentContactWay from './contentContactWay';

import ContentStyle from './content.module.css';
import AdBanner from "../../common/AdBanner/AdBanner";
import globalStyle from '../../styles/globalStyle';


class Content extends Component{

    componentDidMount=()=>{
        window.scrollTo(0,0);
    }

    render(){
        return(
            <div style={{width:'100%'}}>
                <div className={ContentStyle.content}>
                    <ContentMenu />
                    <ContentNews />
                    <div style={{height: 16}}/>
                    <AdBanner width={1200} height={150}/>
                    <ContentFirmAndPolicy />
                    <ContentServiceAdvantage />
                    <ContentPartner />
                </div>
                <ContentReserve />
            </div>
        );

    }
}

export default Content;
